/**
 * Política UX para el toast global de LICENSE_BLOCKED (api.js interceptor).
 * En Panel General e inicios de módulo el aviso inline + CTAs sustituyen el toast flotante.
 */
import { isLicenseCtaHubPath } from "@/modules/panelLicenseHubPaths";
import { isBntAsistentePath } from "@/modules/asistente/bntAsistenteRoutes";

/**
 * Inicios de módulo (hub) — mirror de MODULE_INICIO_PATHS en moduloTabRegistry.js.
 * Tras login suele persistir vf:active_work_module y el usuario entra a /visor/inicio u otra
 * ruta hub; GET /clients desde ModuleClientSelector dispara LICENSE_BLOCKED ahí.
 */
export const LICENSE_BLOCKED_TOAST_SUPPRESS_PATHS = new Set([
  "/",
  "",
  "/visor/inicio",
  "/laboral/inicio",
  "/tramites/inicio",
  "/despacho/inicio",
  "/disenador/inicio",
]);

/** Rutas donde ya hay aviso inline/header de licencia (Panel General o hub de módulo). */
export function isPanelHubPath(pathname = "") {
  return isLicenseCtaHubPath(pathname) || isBntAsistentePath(pathname);
}

/**
 * Si true, no mostrar toast.error por LICENSE_BLOCKED (evita empalme con topbar).
 * @param {string} [pathname] — para tests; en runtime usa window.location.pathname
 */
export function shouldSuppressLicenseBlockedToast(pathname) {
  if (pathname != null && pathname !== "") {
    return isPanelHubPath(pathname);
  }
  if (typeof window === "undefined") return false;
  return isPanelHubPath(window.location.pathname);
}
